<template>
    <el-select :disabled="disabled" multiple v-model="val" placeholder="请选择国家" @change="handleChange" collapse-tags>
        <el-option v-for="item in options" :key="item.id" :value="item.id" :label="item.name"></el-option>
    </el-select>
</template>

<script>
import { country } from "@/api/coupon/list";
export default {
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            val: [],
            options: [],
        };
    },
    watch: {
        value: {
            handler(val) {
                this.val = val;
            },
            immediate: true,
        },
    },
    mounted() {
        this.search();
    },
    methods: {
        search() {
            country().then(({ code, result, error }) => {
                if (code === 200) {
                    this.options = result || [];
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleChange(val) {
            this.$emit("input", val);
            this.$emit("change", val);
        },
    },
};
</script>

<style></style>
